<template>
  <transition>
    <div class="backdrop" :style="styles" @click="$emit('click')"></div>
  </transition>
</template>

<script>
/**
 * Backdrop
 */
export default {
  props: {
    zIndex: {
      type: Number,
      default: 1000,
    },
  },
  computed: {
    styles() {
      return {
        zIndex: this.zIndex,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.backdrop {
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
